import { cva } from "class-variance-authority";
import { AtButtonType } from "./at-button.types";

export const joinClasses = (obj: Record<string, string>) => {
  return Object.values(obj).join(" ");
};

const primary = {
  enabled: "!bg-primary-500 !text-white",
  hover: "hover:!bg-primary-700",
  disabled: "disabled:!bg-surface-75",
};
const secondary = {
  enabled:
    "!bg-white !text-primary-500 !border-solid !border !border-primary-500 ",
  hover:
    "hover:!bg-primary-75 hover:!text-primary-800 hover:!border-primary-800",
  disabled:
    "disabled:!bg-white disabled:!text-surface-75 disabled:!border-surface-75",
};
const tertiary = {
  enabled:
    "!underline !bg-transparent !text-primary-500  disabled:!text-surface-75",
  hover: "hover:!text-primary-700",
  disabled: "disabled:!text-surface-75",
};

const icon = {
  enabled: "!text-current !min-w-auto",
  hover: "hover:opacity-75",
  disabled: "disabled:opacity-50",
};

const breadcrumb = {
  enabled: "!bg-transparent !text-surface-300  disabled:!text-surface-75",
  hover: "hover:!text-primary-700",
  disabled: "disabled:!text-surface-75",
};

const primaryRed = {
  enabled: "!bg-error-500 !text-white",
  hover: "hover:!bg-error-700",
  disabled: "disabled:!bg-surface-75",
};

const secondaryRed = {
  enabled: "!border-solid !border !border-error-500 !text-error-500",
  hover: "hover:!bg-error-75 hover:!text-error-800 hover:!border-error-800",
  disabled:
    "disabled:!bg-white disabled:!text-surface-75 disabled:!border-surface-75",
};

const sizes = {
  none: "!px-0 !py-0 !text-normal",
  extraSmall: "px-8 !py-1 !text-[0.625rem] !leading-[0.875rem]",
  small: "!px-8 !py-1 !text-xs",
  medium: "!px-8 !py-[10px] !text-sm",
  large: "!px-8 !py-3 !text-normal !tracking-normal",
  custom: "",
};

export const buttonVariants = cva(`!font-normal !normal-case`, {
  variants: {
    variant: {
      [AtButtonType.PRIMARY]: joinClasses(primary),
      [AtButtonType.SECONDARY]: joinClasses(secondary),
      [AtButtonType.TERTIARY]: joinClasses(tertiary),
      [AtButtonType.ICON]: joinClasses(icon),
      [AtButtonType.BREADCRUMB]: joinClasses(breadcrumb),
      [AtButtonType.PRIMARY_RED]: joinClasses(primaryRed),
      [AtButtonType.SECONDARY_RED]: joinClasses(secondaryRed),
    },
    size: sizes,
  },
  defaultVariants: {
    variant: AtButtonType.PRIMARY,
    size: "large",
  },
});
